import { createContext } from "react";

export const MarkdownLinkContext = createContext(false);
